import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form, Input, Select, Button, Checkbox } from 'antd'
import { sendNotification } from '../../utils/index'
import { editUser, unsetSelectUserEdit } from '../../actions/UsersAction'
import RequiredField from '../required-field/RequiredField'
const { Option } = Select

export class Edit extends Component {

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      rol: '',
      start: false,
      disableEditButton: true,
      status: false,
      modalNews: false,
      dateAttempsBlock: false,
      roleLower: null,
      options: [],
      group: []
    }
  }

  componentDidMount() {
    const { data } = this.props
    if (data) {
      this.setState({
        ...data,
        rol: data.clientRole,
        group: data.groups,
      })
    }
    const { allGroups } = this.props
    if (allGroups) {
      this.setState({
        options: allGroups.map((r, k) => <Option key={'op_'+ k} value={r.name} uid={r._id}>{r.name}</Option>),
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { data, error, isUpdating, intl } = this.props
    const { start } = this.state

    if (!isUpdating && start && prevProps.data !== data) {
      this.props.handleHideEditUser()
      sendNotification('success', intl, intl.formatMessage({ id: 'updated_user_success' }))
      this.setState({
        start: false,
        name: '',
        email: '',
        rol: ''
      })
    }

    if (!isUpdating && error && prevProps.error !== error) {
      sendNotification('error', intl, intl.formatMessage({ id: 'updated_user_failure' }))
      this.setState({
        start: false
      })
    }

    if (data && data !== prevProps.data) {
      this.setState({
        ...data,
        rol: data.clientRole,
        group: data.groups,
        disableEditButton: true,
      })
    }

  }

  handleInputOnChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
      disableEditButton: e.target.value.length === 0
    })
  }

  handleSelectOnChange = value => {
    this.setState({
      rol: value,
      disableEditButton: false
    })
  }

  handleEdit = () => {
    const { rol, status, modalNews, name, dateAttempsBlock, group } = this.state
    const { workclient, data, intl, allGroups } = this.props
    this.setState({ start: true })
    if (rol !== '') {
      if (rol === 'operator' && group.length === 0) {
        sendNotification('error', intl, intl.formatMessage({ id: 'must_select_group' }))
        return
      }
      const groupsGetId = allGroups.filter(g => group.includes(g.name)).map(item => { return item._id})
      const validGroups = rol === 'operator' ? groupsGetId.length === 0 ? group : groupsGetId : []
      this.props.editUser(workclient, data._id, rol, status, modalNews, name, dateAttempsBlock, validGroups)
    } else {
      sendNotification('warning', intl, intl.formatMessage({ id: 'not_valid_role' }))
    }
  }

  handleCancel = () => {
    this.props.handleHideEditUser()
    this.setState({
      start: false,
    })
  }

  handleStatus = e => {
    const { name } = this.state;
    this.setState({
      status: e.target.checked,
      disableEditButton: name.length === 0,
    });
  }

  handleModalNews = e => {
    const { name } = this.state;
    this.setState({
      modalNews: e.target.checked,
      disableEditButton: name.length === 0,
    });
  }

  handleAttempsBlockDate = e => {
    const { name } = this.state;
    this.setState({
      dateAttempsBlock: e.target.checked,
      disableEditButton: name.length === 0,
    });
  }

  handleOnChangeGroup = (item, list) => {
    this.setState({ 
      group: list.map(r => r.props.uid),
      disableEditButton: false
    })
  }

  render() {
    const { isUpdating, newColor, data, intl, user,  } = this.props
    const {
      disableEditButton,
      name,
      email,
      // status,
      modalNews,
      dateAttempsBlock,
      options,
      rol
     } = this.state



    return (
      <React.Fragment>
        {data &&
          <Form>
            <Form.Item>
              <span>{intl.formatMessage({ id: 'email' })}</span>
              <Input
                disabled={true}
                name="email"
                value={email}
                placeholder={intl.formatMessage({ id: 'email' })}
              />
            </Form.Item>
            <Form.Item>
              <span>{intl.formatMessage({ id: 'name' })}</span>
              <Input
                name="name"
                value={name}
                placeholder={intl.formatMessage({ id: 'name' })}
                onChange={this.handleInputOnChange} />
            </Form.Item>
            <Form.Item>
              <span>{intl.formatMessage({ id: 'role' })}</span>
              <Select name="rol" defaultValue={data.clientRole} onChange={this.handleSelectOnChange} >
                <Option value="operator">{intl.formatMessage({ id: 'operator' })}</Option>
                <Option value="admin">{intl.formatMessage({ id: 'admin' })}</Option>
              </Select>
            </Form.Item>
            {rol === 'operator' && <Form.Item>
              <RequiredField name={intl.formatMessage({ id: 'groups' })} />
              <Select
                mode="multiple"
                defaultValue={data.groups}
                placeholder={intl.formatMessage({ id: 'select' })}
                onChange={this.handleOnChangeGroup}
                style={{ width: '100%' }}>
                {options}
              </Select>
            </Form.Item>}
            {/* <Form.Item>
              <Checkbox onChange={this.handleStatus} checked={status} value='enableNow' ></Checkbox>
              <span><b>&nbsp;{intl.formatMessage({ id: "enableNow" })}  </b> </span>
            </Form.Item> */}
            { user.role === 'admin' && user.clientRole === 'admin' && 
              <Form.Item>
                <Checkbox onChange={this.handleModalNews} checked={modalNews} value='did_you_see_modal' ></Checkbox>
                <span><b>&nbsp;{intl.formatMessage({ id: "did_you_see_modal" })}  </b> </span>
              </Form.Item>
            }
            { user.role === 'admin' && user.clientRole === 'admin' && 
              <Form.Item>
                <Checkbox onChange={this.handleAttempsBlockDate} checked={dateAttempsBlock ? true : false} value='block_user_from_attemps' ></Checkbox>
                <span><b>&nbsp;{intl.formatMessage({ id: "block_user_from_attemps" })}  </b> </span>
              </Form.Item>
            }
              
            
            <Form.Item>
              <Button
                loading={isUpdating}
                disabled={disableEditButton}
                type="primary"
                style={{ backgroundColor: newColor, borderColor: newColor, width: '100px' }}
                onClick={this.handleEdit}>{intl.formatMessage({ id: 'update' })}</Button>
              <Button
                type="default"
                style={{ color: newColor, borderColor: newColor, marginLeft: '5px', width: '87px', justifyContent: 'center' }}
                onClick={this.handleCancel}>{intl.formatMessage({ id: 'cancel_button' })}</Button>
            </Form.Item>
          </Form>
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    isUpdating: state.users.isUpdating,
    data: state.users.data.find(r => r.isEditSelected),
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    error: state.users.error,
    user: state.authUser.user,
    allGroups: state.group.byClientData
  }
}

const mapDispatchToProps = {
  editUser,
  unsetSelectUserEdit
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Edit)))
